import { render, staticRenderFns } from "./SimpleCurrentData.vue?vue&type=template&id=75540746&scoped=true"
import script from "./SimpleCurrentData.vue?vue&type=script&lang=js"
export * from "./SimpleCurrentData.vue?vue&type=script&lang=js"
import style0 from "./SimpleCurrentData.vue?vue&type=style&index=0&id=75540746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75540746",
  null
  
)

export default component.exports